<!-- eslint-disable -->

<template>
	<div class="d-flex flex-column mb-4 bg-white rounded-lg px-4">
		<!-- show Status and Time -->
		<Header :status="status" :dateTime="deadlineDate" />

		<div class="pt-4">
			<div class="text-center">
				<span class="text-gotham" style="font-size: 14px"
					>{{ language == "en" ? "Door Number" : "Nomor Pintu" }} :</span
				>
				<div class="door-number text-gotham-bold">
					{{ doorNumber }}
				</div>
			</div>
			<div v-if="qrCode" class="py-4" style="justify-content:center;display: flex;margin: auto;">
				<Qrcode :value="qrCode" :isBase64="isBase64" />
			</div>
		</div>

		<WarningBox />

		<div class="divider my-4"></div>

		<InfoList :title="language == 'en' ? 'Rent Info' : 'Info Sewa'" :data="rentInfo" />

		<div class="divider my-4"></div>

		<Collapsible
			id="howto"
			:title="language == 'en' ? howToStep.title : howToStep.title_bahasa"
			:open="toogleHowto"
			@onClick="toogleHowto = !toogleHowto"
		>
			<HowTo :content="instruction" />
		</Collapsible>

		<div class="divider my-4"></div>

		<Collapsible
			id="history"
			:title="language == 'en' ? 'Status History' : 'Riwayat Status'"
			:open="toogleHistory"
			@onClick="toogleHistory = !toogleHistory"
		>
			<History :data="logs" />
		</Collapsible>

		<div class="divider my-4"></div>

		<Collapsible
			id="info"
			:title="language == 'en' ? 'PaxelBox Location Info' : 'Info Lokasi PaxelBox'"
			:open="toogleInfo"
			@onClick="toogleInfo = !toogleInfo"
		>
			<div class="px-4 py-2">
				<div class="py-2 text-gotham-bold" style="font-size: 16px;">
					{{ addressMain || "-" }}
				</div>
				<div class="text-gotham text-left" style="font-size: 12px;line-height: 16px;">
					{{ addressDetail || "-" }}
				</div>
				<div class="py-2 " v-if="lat && long">
					<span
						@click="openMapLink"
						class="text-purple text-gotham-bold text-left"
						style="font-size: 12px;line-height: 16px;color: #5e51a1;"
						>{{ language == "en" ? "See map" : "Lihat peta" }} >
					</span>
				</div>
				<div class="py-2 text-gotham text-left" style="font-size: 12px;line-height: 16px;">
					{{ addressAdditionalDetail || "-" }}
				</div>
				<div
					class="py-2 text-gotham text-left"
					style="font-size: 12px;line-height: 16px;white-space:pre-wrap"
				>
					<div>{{ language == "en" ? "Operational Hours" : "Jam Operasional" }} :</div>
					<div class="mt-2">{{ operationalHour || "-" }}</div>
				</div>
				<div class="row px-3">
					<div class="" style="height: 160px;width: 50%;">
						<img
							v-if="locker_photo"
							:src="locker_photo"
							class="image-fit"
							@click="showPhoto(locker_photo)"
							@error="imageUrlNoContent"
							alt="Locker"
						/>
					</div>
				</div>
			</div>
		</Collapsible>

		<div class="divider my-4"></div>

		<Collapsible
			id="payment"
			:title="language == 'en' ? 'Payment Details' : 'Rincian Pembayaran'"
			:open="tooglePaymentDetail"
			@onClick="tooglePaymentDetail = !tooglePaymentDetail"
		>
			<InfoList :data="paymentInfo" />
		</Collapsible>

		<div class="divider my-4"></div>

		<div class="text-center mx-6">
			<button
				class="button rounded-lg py-3 text-gotham-bold"
				style="width: 90%;background-color: white;border: 1px solid #5e51a1;color:#5e51a1;position:relative"
				@click="buttonContactSupport()"
			>
				{{ language == "en" ? "Need help? Contact HERA" : "Butuh bantuan? Hubungi HERA" }}
				<img src="@/assets/images/hera.svg" alt="hera" class="icon-hera-button">
			</button>
		</div>
	</div>
</template>
<script>
/* eslint-disable */
import Header from "./components/Header.vue";
import InfoList from "./components/InfoList.vue";
import Collapsible from "./components/Collapsible.vue";
import History from "./components/History.vue";
import Qrcode from "./components/Qrcode.vue";
import WarningBox from "./components/WarningBox.vue";
import HowTo from "./components/HowTo.vue";

const COUNT_TRIGGER = 10;

export default {
	components: { Header, InfoList, Collapsible, History, Qrcode, WarningBox, HowTo },
	props: {
		status: {
			type: String,
			default: "in-store"
		},
		order: {
			type: Object,
			default() {
				return {};
			}
		},
		boxLocationDetail: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			loadingIcon: true,
			pakpoboxAPIUrl: process.env.VUE_APP_PAKPOBOX_API,
			heraUrl: process.env.VUE_APP_HERA_LINK,
			//
			addressMain: "",
			addressDetail: "",
			addressAdditionalDetail: "",
			mapUrl: '',
      operationalHour: '',
      lat: "",
			long: "",
			locker_photo: "",
			operationalHour: "",
			doorNumber: "-",
			rentDate: "",
			deadlineDate: "",
			orderNumber: "",
			size: "",
			paymentMethod: "",
			payOfAmount: "",
			paymentDetail: {},
			adminFee: {},
			donation: [],
			totalDonation: 0,
			logs: [],
			//
			toogleHowto: true,
			toogleHistory: true,
			toogleInfo: true,
			tooglePaymentDetail: true,
			qrCode: "",
			isBase64: false,
			//
			intervalId: null,
			countStart: COUNT_TRIGGER,
			howToStep: {
				description: "",
				description_bahasa: "",
				title: "",
				title_bahasa: "",
				value: ""
			},
			instruction: ""
		};
	},
	computed: {
		rentInfo() {
			return [
				{
					label: this.language == "en" ? "Rent Start" : "Sewa Dimulai",
					key:"title",
					value: this.rentDate,
					isDate: true
				},
				{
					label: this.language == "en" ? "Rent Ends" : "Batas Akhir Sewa",
					key:"deadlineDate",
					value: this.deadlineDate,
					isDate: true,
					addBreak: true,
				},
				{
					label: this.language == "en" ? "Order Number" : "Nomor Order",
					key:"orderNumber",
					value: this.orderNumber
				},
				{
					label: this.language == "en" ? "PaxelBox Size" : "Ukuran PaxelBox",
					key:"boxSize",
					value: this.size
				}
			];
		},
		paymentInfo() {
			const arr = [
				{
					label: this.language == "en" ? "Rent Fee" : "Biaya Sewa",
					value: this.formatRupiah(this.payOfAmount),
					addBreak: true
				},
				{
					label: this.language == "en" ? "Admin Fee" : "Biaya Admin",
					value: this.formatRupiah(this.adminFee?.total_amount ?? 0),
					addBreak: true
				},
				{
					label: this.language == "en" ? "Total Payment" : "Total Pembayaran",
					value: this.formatRupiah(
						(this.payOfAmount ?? 0) + (this.adminFee?.total_amount ?? 0) + (this.totalDonation ?? 0)
					),
					labelStyle: "font-weight:bold;font-size:14px",
					valueStyle: "font-weight:bold;font-size:16px",
					addBreak: true
				},
				{
					label: this.language == "en" ? "Payment Method" : "Metode Pembayaran",
					value: this.paymentMethod,
					addBreak: true
				}
			];

			if(this.donation){
				const donations = this.donation.map(donate => {
					return {
						label: `${donate.qty} item | ${this.language == "en" ? donate.name.en : donate.name.id}`,
						value: this.formatRupiah(donate.sub_total),
						addBreak: true
					};
				});
	
				arr.splice(1, 0, ...donations);
				return arr;
			}else{
				return arr;
			}
		},
	},
	mounted() {
		this.intervalId = setInterval(this.handleMountStopRent, 1000);

		//check is qrcode is from overdue use the qr from localstorage, if it was stop rent normal case display qr from database
		const qrdisplay = this.$route.query?.qrdisplay;
		if(qrdisplay == "overdue"){
			this.qrCode = localStorage.getItem("qrOverdue");
			this.isBase64 = false;
		}else if (this.order?.barcode?.qrcodeCustomerTake) {
			this.qrCode = this.order?.barcode?.qrcodeCustomerTake;
			this.isBase64 = false;
		}

		this.doorNumber = this.order?.mouth.number;
		this.rentDate = this.order?.createTime;
		var date = new Date(this.order?.overdueDatetime);
		var unixTimeStamp = Math.floor(date.getTime());
		// this.deadlineDate = this.order?.overdueTime;
		this.deadlineDate = unixTimeStamp;
		this.orderNumber = this.order?.expressNumber;
		this.addressMain = this.boxLocationDetail?.locker_location || "-";
		this.addressDetail = this.boxLocationDetail?.location_address || "-";
		this.lat = this.boxLocationDetail?.latitude
		this.long = this.boxLocationDetail?.longitude
		this.mapUrl = this.boxLocationDetail?.maps_link
		this.locker_photo = this.boxLocationDetail?.locker_photo
		this.addressAdditionalDetail = this.boxLocationDetail?.location_description_bahasa || "-";
		this.operationalHour = this?.boxLocationDetail?.operational_hour_bahasa;
		if(this.language == 'en'){
			this.addressAdditionalDetail = this.boxLocationDetail?.location_description || "-";
			this.operationalHour = this?.boxLocationDetail.operational_hour;
		}
		this.size = this.sizeDoorLabel(this.order?.mouth?.mouthType?.name)
		this.paymentMethod = this.order.paymentMethod;
		this.payOfAmount = this.order.payOfAmount;
		this.paymentDetail = this.order.payment_detail;
		this.donation = this.order.donation;
		this.totalDonation = this.order.total_donation;
		this.adminFee = this.order.admin_fee;
		this.logs = this.order.logs;

		this.howToStep = this.getPaxelBoxContentSetting("how_to_stop_rent");

		this.instruction = this.howToStep.description_bahasa?.replaceAll(
			"{{door_number}}",
			this.doorNumber
		);
		if (this.language == "en") {
			this.instruction = this.howToStep.description?.replaceAll("{{door_number}}", this.doorNumber);
		}
	},
	beforeDestroy() {
		clearInterval(this.intervalId);
	},
	methods: {
		openMapLink() {
			this.buttonSyncOpenGmapLocation(this.lat, this.long, this.mapUrl)
		},
		contactHera(url) {
			window.location.href = url;
		},
		async handleMountStopRent() {
			const paramOrderId = this.$route.query.orderid;
			this.countStart -= 1;
			if (this.countStart <= 0) {
				this.countStart = COUNT_TRIGGER;
				return;
			}
		}
	}
};
</script>
<style scoped>
.door-number {
	font-size: 48px;
	color: #ff434f;
}
.divider {
	height: 1rem;
	background-color: #f9f9fb;
	margin-right: -1.5rem;
	margin-left: -1.5rem;
}
.text-16 {
	font-size: 16px;
}
</style>
